export enum Path {
  editService = 'manage/services/add',
  detailService = 'manage/services/detail',
  detailComplaint = 'complaints/detail',
  detailComboPackage = 'manage/combo-packages/detail',
  editComboPackage = 'manage/combo-packages/create',
  detailComboBooking = 'combo-booking/detail',
  listingComboBooking = 'combo-booking',
  detailCustomer = 'manage-customers/detail',
  detailRefundManagment = 'refund-management/detail',
  detailChatManagment = 'chat/detail',
  chatListing = 'chat/list',
  detailLocation = 'manage/locations/detail',
  detailBooking = 'bookings/detail',
  detailCoupons = 'manage/coupons/detail',
  addCoupons = 'manage/coupons/create',
  addPlan = 'manage/plans/view',
}



export enum StorageKeys {
  config = 'config',
}

export enum RequiredPersonalInformation{
  emiratesId = 'emiratesId',
  passport = 'passport',
  emiratesIdAndPassport = 'emiratesIdAndPassport',
}

export enum AdrenalineMeterScale{
  low = 'low',
  average = 'average',
  high = 'high',
}


export enum CategoryType {
  vehchleForGroup = 'vehchleForGroup',
  shared = 'shared',
  single = 'single',
  group = 'group',
}

